import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getUserByUsername } from '../utils/secureFunctions';

const UserByUsername: React.FC = () => {
  const { username } = useParams<{ username: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    const go = async () => {
      if (!username) return;
      try {
        const res = await getUserByUsername(username.toLowerCase());
        if (res?.profile?.uid) {
          navigate(`/profile/${res.profile.uid}`, { replace: true });
          return;
        }
      } catch {}
      navigate('/not-found', { replace: true });
    };
    go();
  }, [username, navigate]);

  return null;
};

export default UserByUsername;
